import { toastr } from 'react-redux-toastr'
import { postJSON } from '../util/metodos'
import { getDeviceId } from '../util/deviceId'
import Moment from 'moment'

export function login(values) {
    return submit(values)
}
export function signup(values) {
    return submit(values)
}

function submit(values) {
    return dispatch => {
        const dados = { ...values, deviceId: getDeviceId() }

        postJSON('login' + (values.tipo === "3" ? '/contador' : (values.tipo === "2" ? '/paciente' : '')), dados).then(resp => {

            if (resp == null || resp.data == null || resp.data.acao === "0") {
                toastr.error('Erro', "Login/Senha Inválido!")
                return
            }

            const usuario = {
                usuario: values.usuario,
                idMedico: parseInt(resp.data.idMedico, 10),
                idConselho: parseInt(resp.data.idConselho || 0),
                idPaciente: parseInt(resp.data.idPaciente, 10),
                idContador: parseInt(resp.data.idContador, 10),
                chapa: resp.data.chapa || "",
                cpdchamado: parseInt(resp.data.cpdchamado, 10),
                token: resp.data.token || "",
                refresh_token: resp.data.refresh_token || "",
                expires_in: Moment().add(parseInt(resp.data.expires_in, 10), 'seconds')
            }

            const codigoValidacao = String(resp.data.codigoValidacao || "").trim()

            // Usuarios que recebem codigoValidacao precisam confirmar o codigo
            // enviado por WhatsApp/e-mail antes de entrar. Nada e gravado no
            // localStorage enquanto a confirmacao nao acontece.
            if (codigoValidacao !== "") {
                dispatch({ type: 'VALIDACAO_PENDENTE', payload: { codigoValidacao, usuario } })
                return
            }

            dispatch({ type: 'USER_FETCHED', payload: usuario })
        })
    }
}

// Confere o codigo digitado contra o que o backend devolveu no login. So depois
// de bater o usuario e efetivamente logado (gravado no localStorage).
export function confirmarCodigoValidacao(codigo) {
    return (dispatch, getState) => {
        const validacao = getState().auth.validacao

        if (validacao == null) return

        const codigoDigitado = String(codigo || "").trim()

        if (codigoDigitado === "") {
            toastr.error('Atenção', "Informe o código de validação.")
            return
        }

        if (codigoDigitado !== String(validacao.codigoValidacao).trim()) {
            toastr.error('Atenção', "Código de validação inválido!")
            return
        }

        dispatch({ type: 'USER_FETCHED', payload: validacao.usuario })
    }
}

// Desiste da validacao e volta para a tela de login.
export function cancelarValidacao() {
    return { type: 'VALIDACAO_CANCELADA' }
}

export function logout() {
    return { type: 'TOKEN_VALIDATED', payload: false }
}

export function validateToken(token) {
    return dispatch => {
        if (token) {
            postJSON('login/valida', { token }).then(resp => {
                if (resp != null)
                    dispatch({ type: 'TOKEN_VALIDATED', payload: resp.data.ok })
            })
        } else {
            dispatch({ type: 'TOKEN_VALIDATED', payload: false })
        }
    }
}
